'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SignInPopup = require('@quixeltools/quixel-ui-library/dist/components/common/website/SignInPopup');

var _SignInPopup2 = _interopRequireDefault(_SignInPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignInPopup = function (_React$Component) {
  (0, _inherits3.default)(SignInPopup, _React$Component);

  function SignInPopup() {
    (0, _classCallCheck3.default)(this, SignInPopup);
    return (0, _possibleConstructorReturn3.default)(this, (SignInPopup.__proto__ || (0, _getPrototypeOf2.default)(SignInPopup)).apply(this, arguments));
  }

  (0, _createClass3.default)(SignInPopup, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_SignInPopup2.default, null);
    }
  }]);
  return SignInPopup;
}(_react2.default.Component);

exports.default = SignInPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SignInPopup/SignInPopup.jsx
// module id = 2750
// module chunks = 0